import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@web/core/query';
import { customerSearchRepository } from '@web/data/repositories';
import type { CustomerHit } from '@web/data/repositories/search/customer_search_repository';
import { useOrgContext } from '@web/ui/core';

const MIN_CHARS = 2;

export interface CustomerSearchState {
  results: readonly CustomerHit[];
  isFetching: boolean;
  isActive: boolean;
}

/**
 * Org-scoped customer (CRM) search over an already-debounced query. A second independent
 * `useQuery` (F1) — degrades on its own without affecting the card query. Disabled until >= 2 chars.
 */
export function useCustomerSearch(debounced: string): CustomerSearchState {
  const { orgId } = useOrgContext();

  const enabled = debounced.length >= MIN_CHARS;
  const query = useQuery({
    queryKey: queryKeys.customerSearch.query(orgId, debounced),
    queryFn: () => customerSearchRepository.search(orgId, debounced),
    enabled,
  });

  return { results: query.data ?? [], isFetching: enabled && query.isFetching, isActive: enabled };
}
